import React, { useState, useRef, useEffect } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShowToast } from '../../../common/Toastr';
import { setItemStatus, getValueFromResource,FormatInvoiceDecimalNumber, determineCommaSeprater, parseLocalizedNumber, formatDateWithDateAndMonthName } from '../../../common/timeLiveFunction';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { Dropdown } from 'react-bootstrap'
import clsx from 'clsx';
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import ProjectTaskTeamAllocationHours from "./ProjectTaskTeamAllocationHours";
import {
    getDataByAllocationHours
} from "../TaskSlice";
import { GetAccountProjectPreferences } from '../projectSlice';

const initialValues = {
    isTeamSelected: true,
    isRelod: false,
    isLoading: true
}

const ProjectTaskTeam = () => {
        const [selectedEmployeeName, setSelectedEmployeeName] = useState(null);
        const [selectedTaskName, setSelectedTaskName] = useState(null);
        const [selectedProjectName, setSelectedProjectName] = useState(null);
        const [selectedTaskId, setSelectedTaskId] = useState(null);
        const [selectedProjectId, setSelectedProjectId] = useState(null);
        const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
        const [selectedProjectTaskEmployeeId, setSelectedProjectTaskEmployeeId] = useState(null);
    const { state } = useLocation();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [teamResponse, setTeamResponse] = useState(initialValues);
    const [projectTaskTeam, setProjectTaskTeam] = useState<any | ''>([]);
    const { AccountProjectId, AccountProjectTaskId, TaskName, Status, StartDate, Deadline, IsEdit } = state.obj;
    const { allocationHoursInProjectTaskTeam } = useAppSelector((state) => state.project);
    const { accountIdsForAllocationHours, cultureInfoName , decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState)
    
    //const { onopenModal } = props;
        const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
        const modelRef = useRef<any>(null);

    useEffect(() => {
         dispatch(GetAccountProjectPreferences());   
        renderrProjectTaskTeam();
    }, []);

    const renderrProjectTaskTeam = async (isSelected: boolean = true) => {
        try {
            const response = await fetchAPI(`api/Tasks/GetAssignedAccountProjectTaskEmployees/${AccountProjectId}/${AccountProjectTaskId}/${isSelected}`, 'Get', '', true);
            const json = await response.json();
            json.map((item: any) => {
                if (isSelected) {
                    item.isSelected = 1;
                } else {
                    item.isSelected = 0;
                }
                item.AllocationHours = item.AllocationHours != null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),item.AllocationHours,2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(),0,2);
            })
            setProjectTaskTeam(json);            
            setTeamResponse({
                ...teamResponse,
                isLoading: false,
                isTeamSelected: isSelected ? true : false
            });
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const onUpdateTeamInTask = async () => {
        setTeamResponse({
            ...teamResponse,
            isLoading: true
        });
        let finalArray: any[] = [];
        projectTaskTeam.map((item: any) => {
            finalArray.push({
                AccountProjectTaskEmployeeId: item.AccountProjectTaskEmployeeId,
                AllocationUnits: 0,
                AllocationHours: item.AllocationHours != null ? parseLocalizedNumber(item.AllocationHours) : 0.00,
                AccountEmployeeId: item.AccountEmployeeId,
                IsSelected: item.isSelected == 1 ? true : false
            })
        });
        try {
            const response = await fetchAPI(`api/Tasks/UpdateProjectTaskEmployee/${AccountProjectId}/${AccountProjectTaskId}`, 'POST', finalArray, true);
            const json = await response.json();
            renderrProjectTaskTeam();
            Number(json.id) > 0 ? ShowToast('Success', json.message, "success", "toast-top-right") :
                ShowToast('Error', "Record(s) Updated Failed!", "error", "toast-top-right");
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const onAddTeamInTask = () => {
        setProjectTaskTeam([]);
        setTeamResponse({
            ...teamResponse,
            isLoading: true
        });
        renderrProjectTaskTeam(false);
    }

    const onCancelTeamInTask = () => {
        setProjectTaskTeam([]);
        setTeamResponse({
            ...teamResponse,
            isLoading: true
        });
        renderrProjectTaskTeam(true);
    }

    const onHandleCalculation = (data: any, id: number) => {
        const value = data.target.value;
        const isComma = determineCommaSeprater(cultureInfoName.toString());
        const hoursRegex = isComma ? /^[0-9]*([,][0-9]{0,2})?$/ : /^[0-9]*([.][0-9]{0,2})?$/;

        if (!hoursRegex.test(value)) return;

        const index = projectTaskTeam.findIndex(
            (item: any) => item.AccountEmployeeId === id
        );

        if (index === -1) return;

        const newArray = [...projectTaskTeam];
        newArray[index].AllocationHours = value;

        setProjectTaskTeam(newArray);
        // const index = projectTaskTeam.findIndex((item: any) => item.AccountEmployeeId === id);
        // const newArray = [...projectTaskTeam];
        // newArray[index].AllocationHours = data.target.value;
        // setProjectTaskTeam(newArray);
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        const newArray = projectTaskTeam.map((item: any) => ({
            ...item,
            isSelected: checked ? 1 : 0
        }));
        setProjectTaskTeam(newArray);
    }

    const onSelectTeamInTask = (e: any, accountEmployeeId: number) => {
        const index = projectTaskTeam.findIndex((item: any) => item.AccountEmployeeId === accountEmployeeId);
        const newArray = [...projectTaskTeam];
        newArray[index].isSelected = e.target.checked ? 1 : 0;
        setProjectTaskTeam(newArray);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {teamResponse.isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Task Employee List')} */}
                        {getValueFromResource('Task Employee List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {teamResponse.isTeamSelected ?
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => { onAddTeamInTask() }}
                                style={{ marginRight: 6 }}
                            >
                                <i className="bi bi-person-plus fs-5 me-1"></i>
                                {/* {t('Add Employees In Task')} */}
                                {getValueFromResource('Add Employees In Task',dispatch, t)}
                            </button>
                            :
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => { onCancelTeamInTask() }}
                                style={{ marginRight: 6 }}
                            >
                                {/* {t('Cancel')} */}
                                {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        }
                        {IsEdit && <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => { onUpdateTeamInTask() }}
                        >
                            <i className="bi bi-pencil-square fs-5 me-1"></i>
                            {/* {t('Update Records')} */}
                            {getValueFromResource('Update Records',dispatch, t)}
                        </button>}
                    </div>
                </div>
                <div className='mt-3'>
                    <div className="d-flex align-items-center mt-2 mb-2">
                        <a className="text-muted fw-bold me-2 fs-2">{TaskName}</a>
                    </div>
                    <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                        <a className="text-gray-500">
                            <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                            {/* {`${moment(StartDate).format('DD MMM yy')} - ${moment(Deadline).format('DD MMM yy')}`} */}
                            {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(Deadline, cultureInfoName.toString())}
                            </a>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(Status))} style={{ lineHeight: 0.8, marginLeft: 4 }}>
                            {Status}
                        </span>
                    </div>
                </div>
                {/* <div className='card-body py-3 mt-2'> */}
                <div className='card-Report-body py-3 mt-2'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th className='min-w-125px'>
                                        {/* {t("Employee Name")} */}
                                        {getValueFromResource('Employee Name',dispatch, t)}
                                        </th>
                                    <th className='min-w-200px'>
                                        {/* {t("Project Name")} */}
                                        {getValueFromResource('Project Name',dispatch, t)}
                                        </th>
                                    <th className='min-w-200px'>
                                        {/* {t("Task Name")} */}
                                        {getValueFromResource('Task Name',dispatch, t)}
                                        </th>
                                    {allocationHoursInProjectTaskTeam && <th className='min-w-125px'>
                                        {/* {t("Allocation Hours")} */}
                                        {getValueFromResource('Allocation Hours',dispatch, t)}
                                        </th>}
                                    <th className=''>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                checked={projectTaskTeam.every((item: any) => item.isSelected === 0) ? false :
                                                    (projectTaskTeam.every((item: any) => item.isSelected === 1 ? true : false))
                                                }
                                                onChange={handleSelectAllChange}
                                            />
                                        </div>
                                    </th>
                                    {accountIdsForAllocationHours && <th className='min-w-100px text-end'></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {projectTaskTeam.length > 0 && projectTaskTeam.map((item: any) => {
                                    return (
                                        <tr key={item.AccountEmployeeId} style={{ height: allocationHoursInProjectTaskTeam ? 42 : 42 }}>
                                            <td>
                                                <a className='text-dark fw-bold d-block'>
                                                    {item.FullName}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.ProjectName}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.TaskName}
                                                </a>
                                            </td>
                                            {allocationHoursInProjectTaskTeam && <td>
                                                <a className='text-gray-800 d-block'>
                                                    <input
                                                        type="text"
                                                        className="form-control inputFieldAlignment"
                                                        name="AllocationHours"
                                                        value={item.AllocationHours}
                                                        onChange={(e) => onHandleCalculation(e, item.AccountEmployeeId)}
                                                    />
                                                </a>
                                            </td>}
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        checked={item.isSelected == 0 ? false : true}
                                                        onChange={(e) => { onSelectTeamInTask(e, item.AccountEmployeeId) }}
                                                    />
                                                </div>
                                            </td>
                                            {accountIdsForAllocationHours && <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {"More"}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"

                                                    >
                                                        <i className="bi bi-three-dots fs-7 " ></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                //onClick={() => { editAccountEmployeeById(item.AccountEmployeeId) }}
                                        onClick={() => {
                                            setSelectedProjectId(item.AccountProjectId);
                                            setSelectedTaskId(item.AccountProjectTaskId);
                                            setSelectedEmployeeId(item.AccountEmployeeId);
                                            setSelectedProjectTaskEmployeeId(item.AccountProjectTaskEmployeeId);
                                            setSelectedProjectName(item.ProjectName);
                                            setSelectedTaskName(item.TaskName);
                                            setSelectedEmployeeName(item.FullName);
                                            dispatch(getDataByAllocationHours({ 
                                                accountProjectId: item.AccountProjectId, 
                                                accountProjectTaskId: item.AccountProjectTaskId, 
                                                accountEmployeeId: item.AccountEmployeeId, 
                                                accountProjectTaskEmployeeId: item.AccountProjectTaskEmployeeId
                                            }))
                                                .unwrap()
                                                .then((originalPromiseResult) => {

                                                    openModal();
                                                })
                                                .catch((rejectedValueOrSerializedError) => {
                                                    console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                })
                                        }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {projectTaskTeam.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t("No Record Found")} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {isModalOpen &&
    <ProjectTaskTeamAllocationHours modelRef={modelRef} t={t} oncloseModal={closeModal} accountprojecttaskid={selectedTaskId} accountprojectid={selectedProjectId} accountEmployeeId={selectedEmployeeId} accountProjectTaskEmployeeId={selectedProjectTaskEmployeeId} selectedProjectName={selectedProjectName} selectedTaskName={selectedTaskName} selectedEmployeeName={selectedEmployeeName} />
}
        </>
    )
}
export default ProjectTaskTeam